import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { QUERY_KEYS, STALE_TIME } from '@/constants';
import churchDashboardService from '@/services/church-dashboard.service';
import { NOTIFICATION_FILTER } from '@/types';

type UseNotificationsOptions = {
  churchId: string;
  cursor?: string;
  limit?: number;
  filter?: NOTIFICATION_FILTER;
  enabled?: boolean;
};

export const useNotifications = ({ churchId, cursor, limit, filter, enabled = true }: UseNotificationsOptions) => {
  return useQuery({
    queryKey: [QUERY_KEYS.DASHBOARD_NOTIFICATIONS, churchId, cursor, limit, filter],
    queryFn: () => churchDashboardService.getNotifications({ churchId, cursor, limit, filter }),
    staleTime: STALE_TIME,
    enabled: enabled && Boolean(churchId),
    retry: (failureCount, error) => {
      if (error instanceof AxiosError && Boolean(error.response)) {
        return false;
      }

      return failureCount < 1;
    },
  });
};
